import { RecordDraft } from '../../types/sharedTypeImpl.ts';


interface Props {
    record: RecordDraft;
    partIndex: number;
    setPartIndex: (partIndex: number) => void;
    isViewMode: boolean;
    onEditPartCountClicked: () => void;
}

export function PartSelectBar({ record, partIndex, setPartIndex, isViewMode, onEditPartCountClicked }: Props) {
    return (
        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            <button style={{ minWidth: '40px' }} type='button' onClick={() => setPartIndex(0)} disabled={partIndex === 0} children='<<' />
            <button style={{ minWidth: '40px' }} type='button' onClick={() => setPartIndex(partIndex - 1)} disabled={partIndex === 0} children='<' />
            <span
                style={{ padding: '0 12px', minWidth: '118px', textAlign: 'center' }}
                children={`Part ${partIndex + 1} of ${record.parts.length}`}
            />
            <button
                style={{ minWidth: '40px' }}
                type='button'
                onClick={() => setPartIndex(partIndex + 1)}
                disabled={partIndex === record.parts.length - 1}
                children='>'
            />
            <button
                style={{ minWidth: '40px' }}
                type='button'
                onClick={() => setPartIndex(record.parts.length - 1)}
                disabled={partIndex === record.parts.length - 1}
                children='>>'
            />

            {!isViewMode && record.measurementType === 'ioqc' && (
                <button style={{ marginLeft: '12px' }} type='button' onClick={onEditPartCountClicked} children='Edit part count' />
            )}
        </div>
    );
}
